/**
 * Situação da categoria que o video está localizado
 */
export enum CategoryVideoStatus {
  ENABLED = 'ENABLED',
  DELETED = 'DELETED',
}

export const translateCategoryVideoStatus = (status: CategoryVideoStatus | string): string => {
  switch (status) {
    case CategoryVideoStatus.ENABLED:
      return 'Ativo';
    case CategoryVideoStatus.DELETED:
      return 'Deletado';
    default:
      return status;
  }
};

export class CategoryVideo {
  business_unit_uuid?: string;
  uuid!: string;
  title!: string;
  description!: string;
  status!: CategoryVideoStatus;
  order!: number;
  created_at!: string;
  updated_at!: string;
}
